'use client';

/*
 * Documentation:
 * Bar Chart — https://app.subframe.com/6fc7f5fbb098/library?component=Bar+Chart_4d4f30e7-1869-4980-8b96-617df3b37912
 */
import { c as _c } from "react/compiler-runtime";
import React from 'react';
import * as SubframeCore from '@subframe/core';
import * as SubframeUtils from '../utils';
interface BarChartRootProps extends React.ComponentProps<typeof SubframeCore.BarChart> {
  stacked?: boolean;
  className?: string;
}
const BarChartRoot = React.forwardRef<React.ElementRef<typeof SubframeCore.BarChart>, BarChartRootProps>(function BarChartRoot(t0, ref) {
  const $ = _c(12);
  let className;
  let otherProps;
  let t1;
  if ($[0] !== t0) {
    ({
      stacked: t1,
      className,
      ...otherProps
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = otherProps;
    $[3] = t1;
  } else {
    className = $[1];
    otherProps = $[2];
    t1 = $[3];
  }
  const stacked = t1 === undefined ? false : t1;
  let t2;
  if ($[4] !== className) {
    t2 = SubframeUtils.twClassNames("h-80 w-full", className);
    $[4] = className;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = ["#402a98", "#b4a7e7", "#2a1b63", "#8773d9", "#20154c", "#573bc9"];
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== otherProps || $[8] !== ref || $[9] !== stacked || $[10] !== t2) {
    t4 = <SubframeCore.BarChart className={t2} ref={ref} stacked={stacked} colors={t3} {...otherProps} />;
    $[7] = otherProps;
    $[8] = ref;
    $[9] = stacked;
    $[10] = t2;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
});
export const BarChart = BarChartRoot;